<template>
 <section class="contact__area pt-115 pb-120">
   <div class="container">
      <div class="row">
         <div class="col-xxl-7 col-xl-7 col-lg-6">
            <div class="contact__wrapper">
               <div class="section__title-wrapper mb-40">
                  <h2 class="section__title"><span class="yellow-bg yellow-bg-big">İletişim<img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
                  <p>Sorularınızı bizimle paylaşabilirsiniz.</p>
               </div>
               <div class="contact__form">
                  <form @submit.prevent="handleSubmit">
                     <div class="row">
                        <div class="col-xxl-6 col-xl-6 col-md-6">
                           <div class="contact__form-input">
                              <input type="text" v-model="formData.name" placeholder="Ad Soyad" required>
                           </div>
                        </div>
                        <div class="col-xxl-6 col-xl-6 col-md-6">
                           <div class="contact__form-input">
                              <input type="email" v-model="formData.email" placeholder="E-posta" required>
                           </div>
                        </div>
                        <div class="col-xxl-12">
                           <div class="contact__form-input">
                              <input type="text" v-model="formData.subject" placeholder="Konu" required>
                           </div>
                        </div>
                        <div class="col-xxl-12">
                           <div class="contact__form-input">
                              <textarea v-model="formData.message" placeholder="Mesajınız" required></textarea>
                           </div>
                        </div>
                        <div class="col-xxl-12">
                           <div class="contact__btn">
                              <button type="submit" class="e-btn" :disabled="loading">
                                 {{ loading ? 'Gönderiliyor...' : 'Gönder' }}
                              </button>
                           </div>
                        </div>
                     </div>
                  </form>
               </div>
            </div>
         </div>
         <div class="col-xxl-4 offset-xxl-1 col-xl-4 offset-xl-1 col-lg-5 offset-lg-1">
            <div class="contact__info white-bg p-relative z-index-1">
               <div class="contact__shape">
                  <img class="contact-shape-1" src="../../assets/img/contact/contact-shape-1.png" alt="">
                  <img class="contact-shape-2" src="../../assets/img/contact/contact-shape-2.png" alt="">
                  <img class="contact-shape-3" src="../../assets/img/contact/contact-shape-3.png" alt="">
               </div>
               <div class="contact__info-inner white-bg">
                  <ul>
                     <li>
                        <div class="contact__info-item d-flex align-items-start mb-35">
                           <div class="contact__info-icon mr-15">
                              <svg class="map" viewBox="0 0 24 24">
                                 <path class="st0" d="M21,10c0,7-9,13-9,13s-9-6-9-13c0-5,4-9,9-9S21,5,21,10z"/>
                                 <circle class="st0" cx="12" cy="10" r="3"/>
                              </svg>
                           </div>
                           <div class="contact__info-text">
                              <h4>Adres</h4>
                              <p>İstanbul</p>
                           </div>
                        </div>
                     </li>
                     <li>
                        <div class="contact__info-item d-flex align-items-start mb-35">
                           <div class="contact__info-icon mr-15">
                              <svg class="mail" viewBox="0 0 24 24">
                                 <path class="st0" d="M4,4h16c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6C2,4.9,2.9,4,4,4z"/>
                                 <polyline class="st0" points="22,6 12,13 2,6 "/>
                              </svg>
                           </div>
                           <div class="contact__info-text">
                              <h4>E-posta</h4>
                              <p><a href="mailto:gelisimpturkiye@gmail.com">gelisimpturkiye@gmail.com</a></p>
                           </div>
                        </div>
                     </li>
                  </ul>
                  <div class="contact__social pl-30">
                     <h4>Instagram hesabımızı takip ediyor musunuz?</h4>
                     <ul>
                        <li><a href="https://www.instagram.com/gelisimpturkiye/" class="insta"><i class="fab fa-instagram"></i></a></li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
 </section>
</template>

<script>
export default {
   name:'ContactArea',
   data() {
      return {
         loading: false,
         formData: {
            name: '',
            email: '',
            subject: '',
            message: ''
         }
      }
   },
   methods: {
      async handleSubmit() {
         try {
            this.loading = true
            const response = await fetch('https://gelisimpturkiye.com/api/sendmail.php', {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json'
               },
               body: JSON.stringify(this.formData)
            })

            const data = await response.json()

            if (data.success) {
               alert('Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.')
               // Formu sıfırla
               this.formData = {
                  name: '',
                  email: '',
                  subject: '',
                  message: ''
               }
            } else {
               throw new Error(data.error || 'Bir hata oluştu')
            }
         } catch (error) {
            console.error('Form gönderme hatası:', error)
            alert('Mesajınız gönderilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.')
         } finally {
            this.loading = false
         }
      }
   }
};
</script>

<style scoped>
.contact__info-icon i {
  font-size: 24px;
  color: #666;
}

.contact__social ul li a.insta i{
   font-size: 24px;
  color: #E4405F;
  transition: all 0.3s ease;
}
.contact__social ul li a.insta:hover i {
  color: #E4405F;
}

.e-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>

